/* 家长的学习目标页面 */
<template>
<div>
  <div>
    <span class='flex-row flex-center target-header' style="color: orange">家长目标</span>
    <div v-if="parent_target.reading_desc" style="text-indent: 2px;font-size: 15px" v-html="addDiv(parent_target.reading_desc)"></div>
  </div>
  <div class="flex-row flex-center">
    <div class="target-page flex-column">
      <div class="flex-row target target-read" v-if="parent_target.parentArticle_content">
          <div class="target-img"><img src="/static/images/parentReading.svg"></div>
          <div>
              <div class="title" id="reading_desc">本周需要阅读{{parent_target.parentArticle_content.length}}篇启蒙文章</div>
              <div class="resource-list">
                <li v-for="article in parent_target.parentArticle_content">
                  <a :href="article.link">{{article.title}}</a>
                </li>
              </div>
          </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/target.css')
import BaseVue from '@/components/BaseVue'

export default {
  name: 'ParentTarget',
  extends: BaseVue,
  props: ['parent_target'],
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/target/ParentTarget.vue